// extracted by mini-css-extract-plugin
export default {"back_icon":"Logout_back_icon__qM0vU"};